import React from 'react'
import { compose, withState, lifecycle } from 'recompose';
import { Helmet } from 'react-helmet';
import includes from 'lodash/includes';
import glamorous from 'glamorous';
import { withRouter } from 'react-router';
import { signOut } from 'firebase/functions';
import {
  AppBar,
  Avatar,
  SelectField,
  MenuItem,
  IconMenu,
  IconButton,
  Drawer,
} from 'material-ui'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import muiThemeable from 'material-ui/styles/muiThemeable';

import Navigator from 'components/Navigator';
import StoreLogo from 'components/images/StoreLogo';
import Previewer from 'pages/CustomPages/children/Previewer'
import { appBackground ,panelWidth, collapseWidth } from 'helpers/muiTheme/themeHelpers';

import navigation from './navigation.json';

const AppContainer = muiThemeable()(
  glamorous.div((props) => ({
    backgroundColor: appBackground,
    height: `calc(100% - ${props.muiTheme.appBar.height}px)`,
    overflow: 'auto',
    transition: '450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  }),
  ({ collapse }) => ({
    paddingLeft: collapse ? collapseWidth : panelWidth,
  })),
);

const CmsApp = compose(
  withState('valueTab', 'setValueTab', 0),
  withRouter,
  withState('collapse', 'setCollapse', false),
  lifecycle({
    componentWillMount() {
      const { location: { pathname } } = this.props
      if(includes(pathname, 'edit') || includes(pathname, 'view')){
        this.props.setCollapse(true)
      }
    },
    componentWillReceiveProps(nextProps){
      const { location: { pathname } } = nextProps
      if(this.props.location.pathname !== pathname && includes(pathname, 'edit')){
        this.props.setCollapse(true)
      }
    }
  }),
  muiThemeable())(
  ({
    children,
    preferences,
    collapse,
    setCollapse,
    valueTab,
    setValueTab,
    muiTheme: { CustomSelectItemNavBar, CustomIconNavBar, appBar, CustomSideBar },
    location: { pathname },
  }) => {
    const isDemo = pathname === '/demo';
    return (
      <div className="App" style={{ height: '100vh' }}>
        <Helmet>
          <link rel="stylesheet" type="text/css" href={preferences.css} />
        </Helmet>
        <Previewer />
        <div>
          <AppBar
            title={
              <StoreLogo logo={preferences.logo} />
            }
            style={{ boxShadow: '0 3px 4px 0 rgba(0,0,0,0.14), 0 3px 3px -2px rgba(0,0,0,0.12), 0 1px 8px 0 rgba(0,0,0,0.2)' }}
            iconElementLeft={
              <SelectField
                value={valueTab}
                // todo เปลี่ยนค่า value เป็นลิ้งค์
                // กดแล้วให้เปิดแท็บใหม่ลิ้งค์ไปเซอร์วิซ และ ไม่ต้องเปลี่ยน value
                onChange={(event, value) => setValueTab(value)}
                underlineStyle={CustomSelectItemNavBar.underlineStyle}
                style={CustomSelectItemNavBar.style}
                labelStyle={CustomSelectItemNavBar.labelStyle}
              >
                <MenuItem value={0} primaryText="CMS" />
              </SelectField>
            }
            iconStyleLeft={{
              margin: 'auto',
            }}
            iconStyleRight={{
              margin: 'auto',
            }}
            iconElementRight={
              <div style={{ height: appBar.height, display: 'inline-flex' }}>
                <IconMenu
                  iconButtonElement={(
                    <IconButton iconStyle={CustomIconNavBar} >
                      <MoreVertIcon />
                    </IconButton>
                  )}
                  anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                  targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                  style={{ width: appBar.height, height: appBar.height }}
                >
                  <MenuItem primaryText="Log out" onTouchTap={() => signOut()} />
                </IconMenu>
                <div style={{ paddingTop: 5 }} >
                  <Avatar
                    src="https://wog.ua/images/user_icon.png"
                    size={35}
                  />
                </div>
              </div>
            }
          />
        </div>
        {!isDemo ?
          [
            <Drawer
              key="drawer"
              width={collapse ? collapseWidth : panelWidth}
              containerStyle={{
                zIndex: 1000,
                transition: '450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
                backgroundColor: CustomSideBar.backgroundColor,
                boxShadow: CustomSideBar.boxShadow,
              }}
            >
              <Navigator
                collapse={collapse}
                userRole="admin"
                navigationData={navigation}
                toggleCollapse={() => setCollapse(!collapse)}
              />
            </Drawer>,
            <AppContainer key="app-container" collapse={collapse}>
              {children}
            </AppContainer>,
          ]
          :
          children
        }
      </div>
    );
  },
);

CmsApp.propTypes = {}
CmsApp.defaultProps = {}

export default CmsApp



// WEBPACK FOOTER //
// ./src/components/App/CmsApp.js